import "./age-dashboard.scss";

import { GetResponseReportCardStat } from "@factory/model/query-model-report";
import { useQyGetAgeRangeReport } from "@factory/query/report.query";
import { DashboardModel } from "@shared/models/dashboard-model";
import { LabelValue } from "@shared/models/label-value.interface";
import { Chart } from "primereact/chart";
import { useState } from "react";
import { FaChartPie } from "react-icons/fa6";

 
export interface AgeDashboardProps {}

export function AgeDashboard() {
  // DECLARATIONS

  // API DEFINITIONS
  const handleAgeSuccess = (response: GetResponseReportCardStat) => {
    const responseData = response.data || ([] as LabelValue[]);

    if (responseData.length === 0) {
      return;
    }
    const labels = responseData.map((item) => item.label);
    const value = responseData.map((item) => item.value);
    const documentStyle = getComputedStyle(document.documentElement);

    const data = {
      labels,
      datasets: [
        {
          label: "Age Range",
          data: value,
          backgroundColor: [
            documentStyle.getPropertyValue("--blue-500"),
            documentStyle.getPropertyValue("--yellow-500"),
            documentStyle.getPropertyValue("--green-500"),
            documentStyle.getPropertyValue("--teal-500"),
            documentStyle.getPropertyValue("--red-500"),
            documentStyle.getPropertyValue("--purple-500"),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue("--blue-300"),
            documentStyle.getPropertyValue("--yellow-300"),
            documentStyle.getPropertyValue("--green-300"),
            documentStyle.getPropertyValue("--teal-300"),
            documentStyle.getPropertyValue("--red-300"),
            documentStyle.getPropertyValue("--purple-300"),
          ],
          borderWidth: 1,
        },
      ],
    };
    const options = {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  };
  const { data: ageRangeResponse } = useQyGetAgeRangeReport(
    undefined,
    undefined,
    undefined,
    true,
    handleAgeSuccess
  );
  ageRangeResponse?.data?.map(
    (item) =>
      new DashboardModel(
        item.label || "-",
        item.value,
        <FaChartPie />,
        undefined,
        undefined
      )
  );

  // LOCAL FUNCTIONS
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  // LOCAL RENDERS

  return (
    <div id="AgeDashboard" className="age-dashboard mb-36">
      <Chart type="bar" data={chartData} options={chartOptions} />
    </div>
  );
}

export default AgeDashboard;
